import { ThemeProvider } from "@emotion/react";
import SearchIcon from "@mui/icons-material/Search";
import { TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import { createTheme } from "@mui/material/styles";
import { withStyles } from "@mui/styles";
import * as React from "react";

const colortheme = createTheme({
  palette: {
    error: {
      main: "#c1c1c1"
    },
    primary: {
      main: "#292739",
    },
    secondary: {
      main: "#c1c1c1",
    },
  },
  typography: {
    fontFamily: ["lato"].join(","),
  },
});

const WhiteTextField = withStyles({
  root: {
    '& .MuiInputBase-input': {
      color: '#fff', // Text color
      fontSize: "14px",
    },
  },
})(TextField);

const UserAutoComplete = withStyles({
  root: {
    width: "100%",
    height: "100%",

    '& .MuiOutlinedInput-root': {
      height: "100%",
      '& .MuiInputBase-root': {
        paddingRight: "0px",
      }
    },
    '&.MuiAutocomplete-hasPopupIcon .MuiFormControl-root .MuiOutlinedInput-root.MuiInputBase-root':{
      paddingRight: "0px",
    },
    '& .MuiFormControl-root .MuiOutlinedInput-root': {
      padding: "0px",
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none'
      },
      '& .MuiAutocomplete-endAdornment': {
        display: 'none'
      }
    },
    '& .MuiAutocomplete-popper': {
      background: '#000000',
    },

  },
})(Autocomplete);

const top100Films = [
  { title: "The Shawshank Redemption", year: 1994 },
  { title: "The Godfather", year: 1972 },
  { title: "The Godfather: Part II", year: 1974 },
  { title: "The Dark Knight", year: 2008 },
  { title: "12 Angry Men", year: 1957 },
  { title: "Schindler's List", year: 1993 },
  { title: "Pulp Fiction", year: 1994 },
]

interface SearchInputProps{
  placeholder?: string
}

const SearchInput: React.FC<SearchInputProps> = ({placeholder}) => {
  return (
    <ThemeProvider theme={colortheme}>
      <Paper
        component="form"
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          height: "55px",
          // paddingRight: "12px",
          backgroundColor: "#312F41",
          borderRadius: "20px",
          boxShadow: "none",
        }}
      >
        <IconButton
          type="submit"
          sx={{ color: "#c1c1c1", padding: "10px" }}
          aria-label="search"
        >
          <SearchIcon style={{ fontSize: "30px" }} />
        </IconButton>
        <UserAutoComplete
          id="free-solo-2-demo"
          options={top100Films.map((option) => option.title)}
          renderInput={(params) => (
            <WhiteTextField
              {...params}
              sx={{ ml: 1, flex: 1, color: "#ffffff", height: "55px", padding: "unset", margin: "unset", fontSize: "14px" }}
              placeholder={`${placeholder ? placeholder : 'Search hashtags or usernames…'}`}
              InputProps={{
                ...params.InputProps,
                type: "search"
              }}
            />
          )}
        />
      </Paper>
    </ThemeProvider>
  );
};

export default SearchInput;